import api from '..'
import { CustomerBalanceResponse } from './types'
import { logger } from '../../utils/logger'

export const getCustomerBalanceFn = async (
  {
    page = '1',
    from,
    to
  }: { page: string, from: string, to: string }
) => {
  try {
    const queryParams = new URLSearchParams({
      page,
      from,
      to
    })
    const response = await api.get<CustomerBalanceResponse>(`auth/customer/balance?${queryParams}`)
    return response.data
  } catch (error) {
    logger.logError(error instanceof Error ? error : new Error('Get balance error'), {
      type: 'get_balance_error',
      page,
      from,
      to
    })
    throw error
  }
}
